export default __webpack_public_path__ + "static/media/shopify.b21ae0c8.svg";